import { MockPlan } from "./MockPlan";
import { Status, Subscription, SubscriptionKind } from "../Subscription";

export class MockSubscription implements Subscription {
  private static INDEX = 0;

  public cancelAtPeriodEnd = false;
  public activeUntil = new Date().toString();
  public kind = SubscriptionKind.STRIPE;
  public plan = new MockPlan();
  public status = Status.ACTIVE;
  public id: string;
  constructor() {
    this.id = `${MockSubscription.INDEX++}`;
  }
}
